import React, { FunctionComponent } from "react";

import { bemClassNames, doNothing } from "@multiweb/reactUtils";
import { TextAlign } from "@multiweb/types/react";
import { ComponentTheme } from "@multiweb/uiShared/ComponentTheme";
import { Cursor } from "../../../../Global/Base/Enums";
import { ButtonBackgroundColor, ButtonProvider } from "../ButtonProvider";
import { Text, WhiteSpace } from "../Text";
import { NoEditFakeComponentProps } from "../types";

export type ButtonFakeComponentProps = Pick<NoEditFakeComponentProps, "value" | "title">;

const classNames = bemClassNames("button-edit-fake-component");
export const ButtonFakeComponent: FunctionComponent<ButtonFakeComponentProps> = ({ value, title }) => (
    <div className={classNames()}>
        <ButtonProvider
            disabled={true}
            onClick={doNothing}
            backgroundColor={ButtonBackgroundColor.transparent}
            theme={ComponentTheme.default}
            cursor={Cursor.default}
            textAlign={TextAlign.start}
            width="100%"
            {...{ title }}
        >

            <Text
                isTextSelectable={false}
                whiteSpace={WhiteSpace.nowrap}
                ellipsis={true}
                disabled={true}
                {...{ value }}
            />
        </ButtonProvider>
    </div>
);
